var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCosmostation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 165,
    viewBox: "0 0 180 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8547 132.699L26.7381 73.6052C25.0092 70.6104 25.0092 66.9054 26.7381 63.9106L60.8547 4.84733C62.5837 1.85248 65.7946 0 69.2526 0H137.486C140.944 0 144.155 1.85248 145.884 4.84733L180 63.9415L163.235 73.6361L131.866 19.3893H74.81L46.2818 68.7888L77.5888 123.036L60.8238 132.73L60.8547 132.699Z",
    fill: "#9C6CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.717 164.809H42.5144C39.0565 164.809 35.8455 162.957 34.1165 159.962L0 100.868L16.765 91.1732L48.0719 145.42H105.097L133.626 96.0206L102.319 41.7738L119.084 32.0791L153.2 91.1732C154.929 94.1681 154.929 97.873 153.2 100.868L119.084 159.962C117.355 162.957 114.144 164.809 110.686 164.809H110.717Z",
    fill: "#05D2DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmostation);
export default __webpack_public_path__ + "static/media/cosmostation.c3099ce0ca9158a681b7298a9b151e8e.svg";
export { ForwardRef as ReactComponent };